// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import iView from 'view-design'
import VueCookies from 'vue-cookies'

import App from './App'
import { router } from './router'
import store from './store'
import http from './services/http'
import './directives/CheckAuth'

import 'view-design/dist/styles/iview.css';
import './assets/styles/index.less'

Vue.use(iView)
Vue.use(VueCookies)

Vue.prototype.$http = http

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV === 'development'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
